export default __webpack_public_path__ + "static/media/honeycomb_left.b31f73b2.svg";